import { PaypalCancelController } from './paypal-cancel.controller';

export const PaypalCancelComponent: ng.IComponentOptions = {
    template: require('./paypal-cancel.html'),
    controller: PaypalCancelController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-cancel/paypal-cancel.component.ts